import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Heading from "../../../../components/heading/Heading";
import { HEADING } from "../../../../components/heading/constants/constants";
import Icons from "../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import styles from "./MultiSelectRecipientsActionCard.styles";
import { componentKey, setBulkAddressMatchModalOpen, setBulkInActivateModalOpen, setBulkReActivateModalOpen, setDeleteRecipientConfirmationModalOpen, setExportToExcelModal, setRequestConsentModalOpen } from "../RecipientListSlice";
import { setTinMatchConfirmationModalOpen } from "../tinmatchmodals/TinMatchSlice";
import { setBulkW8RequestConfirmationModal } from "../bulkw8requestmodals/BulkW8RequestModalSlice";
import { setFirstConfirmationModalOpen } from "../bulkw9requestmodals/BulkW9RequestModalSlice";
import { ShowForAllowedPermissionsOnly } from "../../../wrappers/ShowForAllowedPermissionsOnly";
import { PAGE_PERMISSIONS } from "../../../dashboard/constants/constant";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { setShowPaymentNotAllowedPopup } from '../../../dashboard/DashboardSlice';
import { isAccessAllowed, useUserPermissionsInfo } from "../../../dashboard/hooks/userHooks";
import { blockTinRequest, unBlockTinRequest } from "../RecipientListSaga";
import Loadable from "../../../../components/loadable/Loadable";
import { BLOCKED, FIELDS_TEXTS, MISSING_RECIPIENT_DATA_TEXT, RECIPIENT_LISTING_LOADING_STATES, UNBLOCKED } from "../constants";
import General from "../../../../../libs/utility/General";

export default function MultiSelectRecipientsActionCard() {

    const dispatch = useDispatch();
    const { permissions } = useUserPermissionsInfo();
    const { selectedRecipients, loadingState } = useSelector((state) => state[componentKey]);

    const isRecipientActive = (callback = () => { }) => {
        if (selectedRecipients?.every(rec => rec?.ISActive)) {
            callback();
        } else {
            dispatch(addNotifications({ heading: "Error", message: "This action cannot be processed for inactive recipients" }));
        }
    }

    const isEmailExist = (callback = () => { }) => {
        if (selectedRecipients?.every(rec => rec?.emailid)) {
            callback()
        } else {
            dispatch(addNotifications({ heading: "Error", message: "Note: As the emailids are missing | Email address not present" }));
        }
    }

    return (
        <>
            <div style={styles.header}>
                <Icons familyName='vec' iconName={VEC_ICON_NAME.MULTIPLE_SELECT_ICON} />
                <Heading type={HEADING.H1} customStyle={{ margin: "0" }}>You have selected {selectedRecipients.length} {selectedRecipients?.length === 1 ? "Recipient!" : "Recipients!"}</Heading>
                <p style={styles.headerText}>Here are some recommended actions for you</p>

            </div>

        <Loadable currentState={loadingState.state} loadingStates={[RECIPIENT_LISTING_LOADING_STATES.BLOCK_TIN_MATCH_LOADING, RECIPIENT_LISTING_LOADING_STATES.UNBLOCK_TIN_MATCH_LOADING]} isNewLoadable={true}>
            <div style={styles.buttonWithOutBorder}>

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => {
                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                            if (selectedRecipients?.length > 1) {
                                isRecipientActive(() => isEmailExist(() => dispatch(setBulkW8RequestConfirmationModal(true))))
                            } else {
                                isRecipientActive(() => dispatch(setBulkW8RequestConfirmationModal(true)))
                            }
                        } else {
                            dispatch(setShowPaymentNotAllowedPopup(true))
                        }
                    }}
                >
                    Bulk W8 Request
                </Button>

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => {
                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                            if (selectedRecipients?.length > 1) {
                                isRecipientActive(() => isEmailExist(() => dispatch(setFirstConfirmationModalOpen(true))))
                            } else {
                                isRecipientActive(() => dispatch(setFirstConfirmationModalOpen(true)))
                            }
                        } else {
                            dispatch(setShowPaymentNotAllowedPopup(true))
                        }
                    }}
                >
                    Bulk W9 Request
                </Button>

                {selectedRecipients.length === 1 && selectedRecipients[0]?.TinStatus ?
                        <>
                            {selectedRecipients[0]?.TinStatus !== BLOCKED && <Button
                                type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                style={styles.buttonLight}
                                prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                                onClickCb={() => dispatch(blockTinRequest(selectedRecipients[0]))}
                            >
                                Request TIN Block
                            </Button>}
                            {selectedRecipients[0]?.TinStatus === BLOCKED && <Button
                                type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                                style={styles.buttonLight}
                                prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                                onClickCb={() => dispatch(unBlockTinRequest(selectedRecipients[0]))}
                            >
                                Request TIN Unblock
                            </Button>}
                        </>
                        :
                        selectedRecipients?.some(item => item?.IdNumber?.length !== 0) &&
                    <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                        onClickCb={() => {
                            if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                                if((selectedRecipients.length === 1 && selectedRecipients[0]?.IdNumber && selectedRecipients[0]?.LastName) || selectedRecipients.length > 1 ){
                                    isRecipientActive(() => dispatch(setTinMatchConfirmationModalOpen(true)))
                                }else{
                                    dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }))
                                }
                            } else {
                                dispatch(setShowPaymentNotAllowedPopup(true))
                            }
                        }}
                    >
                        Request TIN Match
                    </Button>
                }

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => isRecipientActive(() => dispatch(setBulkAddressMatchModalOpen(true)))}
                >
                    Bulk Address Match
                </Button>

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => {
                        if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                            if (General.arrayObjectsKeyIsNotEmpty(selectedRecipients, FIELDS_TEXTS.EMAIL_ID_TEXT) && General.arrayObjectsKeyIsNotEmpty(selectedRecipients, FIELDS_TEXTS.LASTNAME_TEXT) && General.arrayObjectsKeyIsNotEmpty(selectedRecipients, FIELDS_TEXTS.IDNUMBER_TEXT)) {
                                isRecipientActive(() => dispatch(setRequestConsentModalOpen(true)))
                            }else{
                                dispatch(addNotifications({ heading: "Error", message: MISSING_RECIPIENT_DATA_TEXT }))
                            }
                        } else {
                            dispatch(setShowPaymentNotAllowedPopup(true))
                        }
                    }}
                >
                    Request Consent
                </Button>

                <Button
                    type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                    style={styles.buttonLight}
                    prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                    onClickCb={() => isRecipientActive(() => dispatch(setExportToExcelModal(true)))}
                >
                    Export To Excel
                </Button>

                <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.DELETE_RECIPIENT}>
                    <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.DELETE_ICON }}
                        onClickCb={() => dispatch(setDeleteRecipientConfirmationModalOpen(true))}
                    >
                        Delete
                    </Button>
                </ShowForAllowedPermissionsOnly>

                <ShowForAllowedPermissionsOnly toCheck={PAGE_PERMISSIONS.EDIT_RECIPIENT}>
                    <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                        onClickCb={() => dispatch(setBulkInActivateModalOpen(true))}
                    >
                        Bulk Inactivate
                    </Button>

                    <Button
                        type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER}
                        style={styles.buttonLight}
                        prefixProps={{ icon: VEC_ICON_NAME.REPORT_ICON }}
                        onClickCb={() => dispatch(setBulkReActivateModalOpen(true))}
                    >
                        Bulk Reactivate
                    </Button>
                </ShowForAllowedPermissionsOnly>
            </div>
        </Loadable>
        </>
    )
}